import React from "react";
import {
  ArrowUp,
  ClipboardList,
  Users,
  Package,
  Building2,
} from "lucide-react";
import { cn } from "@/lib/utils";

interface StatCardProps {
  title: string;
  value: string;
  percentage: string;
  type: "orders" | "revenue" | "visitors" | "products" | "sites";
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  percentage,
  type,
}) => {
  const getIcon = () => {
    switch (type) {
      case "orders":
        return <ClipboardList size={24} className="text-white opacity-80" />;
      case "revenue":
        return <Users size={24} className="text-white opacity-80" />;
      case "visitors":
        return <Users size={24} className="text-white opacity-80" />;
      case "products":
        return <Package size={24} className="text-white opacity-80" />;
      case "sites":
        return <Building2 size={24} className="text-white opacity-80" />;
      default:
        return null;
    }
  };

  const getGradientColors = (type: string) => {
    switch (type) {
      case "orders":
        return "from-blue-600 to-blue-400";
      case "revenue":
        return "from-green-600 to-green-400";
      case "visitors":
        return "from-purple-600 to-purple-400";
      case "products":
        return "from-orange-600 to-orange-400";
      case "sites":
        return "from-red-600 to-red-400";
      default:
        return "from-gray-600 to-gray-400";
    }
  };

  return (
    <div
      className={cn(
        "p-6 rounded-lg shadow-sm",
        `bg-gradient-to-r ${getGradientColors(type)}`
      )}
    >
      <div className="flex justify-between items-start">
        <div>
          <h3 className="text-3xl font-bold mb-3 text-white">{value}</h3>
          <p className="text-sm text-white/80">{title}</p>
        </div>
        <div>{getIcon()}</div>
      </div>
      <div className="mt-4">
        <div className="w-full bg-white/20 h-1.5 rounded-full">
          <div className="bg-white h-1.5 rounded-full w-2/3"></div>
        </div>
        <div className="mt-2 flex items-center gap-1">
          <ArrowUp size={14} className="text-white/90" />
          <span className="text-sm font-medium text-white/90">
            {percentage}
          </span>
        </div>
      </div>
    </div>
  );
};

export default StatCard;
